import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ReportsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ReportsIcon = ({ className, ...props }: ReportsIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 21H15M9 21V16M9 21H3.6C3.26863 21 3 20.7314 3 20.4V16.6C3 16.2686 3.26863 16 3.6 16H9M15 21V9M15 21H20.4C20.7314 21 21 20.7314 21 20.4V12V3.6C21 3.26863 20.7314 3 20.4 3H15.6C15.2686 3 15 3.26863 15 3.6V9M15 9H9.6C9.26863 9 9 9.26863 9 9.6V16"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default ReportsIcon;
